import { createSelector } from '@ngrx/store';

import { wizzardState } from '../root';

export const getWizzardSimpleItemUnitPrice = createSelector(wizzardState, (wizzard) => (wizzard.itemsSimple ? wizzard.itemsSimple.UnitPrice : null));
